import api from '../../api'

export async function getCartPresetByCode(code) {
  const response = await api.get(`/b2c/public/cart_presets/by_code/${code}`)
  return response.data
}
